import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./image.css.ts.vanilla.css-mistica.js";
var v = 300, _ = "_17tt25r5", t = "_17tt25r6", i = "_17tt25r3 _1y2v1nfkr _1y2v1nfl6 _1y2v1nfhm _1y2v1nfi7 _1y2v1nfio _1y2v1nfmf _1y2v1nfjz _1y2v1nfk0 _1y2v1nfkb", d = "_17tt25r1", f = "_17tt25r4", e = {
    mediaBorderRadius: "var(--_17tt25r0)"
};
export { v as FADE_IN_DURATION_MS, _ as circularBorderRadius, t as defaultBorderRadius, i as image, d as imageWithBorder, f as noBorderRadius, e as vars };
